import React, { useState, useEffect } from 'react'
import { Button } from 'antd'
import { Moment } from '../../helpers'

export const InformfixDateTime = (props) => {
  const [fontcolor, setFontColor] = useState()

  useEffect(() => {
    switch (props.jobStatus) {
      case -2:
        setFontColor('red')
        break
      case -1:
        setFontColor('red')
        break
      case 1:
        setFontColor('#068a1a')
        break
      case 2:
        setFontColor('#068a8a')
        break
      case 3:
        setFontColor('#797a7a')
        break
    }
  })

  // แสดงวันที่
  const showFormatDate = (datetime) => {
    let date = Moment(datetime)
    if (date.isValid()) {
      return date.format('ll')
    } else {
      return
    }
  }
  // แสดงเวลา
  const showFormatTime = (datetime) => {
    const time = Moment(datetime)
    if (time.isValid()) {
      return (
        <Button shape="round" style={{ color: fontcolor }} size="small">
          {time.format('LT')} น.
        </Button>
      )
    } else {
      return
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          display: 'inline-block',
        }}
      >
        <div align="center" style={{ fontSize: '0.8rem' }}>
          {showFormatDate(props.datetime)}
        </div>
        <div align="center">{showFormatTime(props.datetime)}</div>
      </div>
    </React.Fragment>
  )
}
